import { Controller } from "react-hook-form";

import { QuestionForMain } from "@/components/features/_layouts/island/main/question";

import { Button } from "@/components/ui/button/button";
import { FormErrorMessage, FormItem } from "@/components/ui/form/_base/form";
import { SelectField } from "@/components/ui/form/fields/select-field";
import { InputTextFieldRHF } from "@/components/ui/form/fields-rhf/input-field/input-text";

import { useFormPhoneNumbers } from "./use-form-phone-numbers";
import { useGoogleFreeBookingLinksSettingsContext } from "../../../_context";

export const FormPhoneNumbers = () => {
	const { form } = useGoogleFreeBookingLinksSettingsContext();
	const {
		register,
		control,
		formState: { errors },
	} = form;

	const {
		phoneTypeOptions,
		phoneNumberFields,
		disabledAppendPhoneNumber,
		handleClickAppendPhoneNumber,
		handleClickRemovePhoneNumber,
	} = useFormPhoneNumbers({ form });

	return (
		<QuestionForMain
			title={"電話番号"}
			inputChildren={
				<FormItem className="flex flex-col gap-6">
					{/* 全体に対するバリデーションエラー */}
					<FormErrorMessage className="static">{errors.phoneNumbers?.message}</FormErrorMessage>

					{phoneNumberFields.map((field, index) => {
						return (
							<div key={field.id} className="relative w-1/2 min-w-60 rounded border p-4 pt-4">
								<Button
									variant="outline"
									className="absolute right-2 top-2 z-10"
									onClick={handleClickRemovePhoneNumber(index)}
								>
									削除
								</Button>

								<div className="flex flex-wrap gap-4">
									<InputTextFieldRHF
										label="電話番号"
										errorMessage={errors?.phoneNumbers?.[index]?.phoneNumber?.message}
										className="w-40"
										{...register(`phoneNumbers.${index}.phoneNumber`)}
									/>

									<Controller
										name={`phoneNumbers.${index}.phoneType`}
										control={control}
										render={({ field }) => (
											<div className="flex flex-col gap-2">
												<SelectField
													label="電話番号の種類"
													className="w-fit"
													value={field.value}
													options={phoneTypeOptions}
													errorMessage={errors?.phoneNumbers?.[index]?.phoneType?.message}
													handleValueChange={field.onChange}
												/>
											</div>
										)}
									/>
								</div>
							</div>
						);
					})}

					<Button
						variant="outline"
						className="w-fit"
						onClick={handleClickAppendPhoneNumber}
						disabled={disabledAppendPhoneNumber}
					>
						電話番号を追加
					</Button>
				</FormItem>
			}
		/>
	);
};
